import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Dashboard = lazy(() => import('../../container/dashboard'));
// const CRM = lazy(() => import('../../container/dashboard/CRM'));

const DashboardRoutes = () => {
  return (
    <Routes>
      <Route exact path="*" element={<Dashboard />} />
    </Routes>
  );
};

export default DashboardRoutes;
